import { createInstance } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { i18nextConfig, type LanguageResource } from "@newtri/core";

declare module "i18next" {
	interface CustomTypeOptions {
		defaultNS: "web";
		resources: LanguageResource;
	}
}

export async function createI18n() {
	const i18n = createInstance({ ...i18nextConfig, defaultNS: "web" })
		.use(LanguageDetector)
		.use(initReactI18next);

	await i18n.init();

	return i18n;
}
